import React from 'react';
import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Autoplay, Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {useSliderBanners} from '@/framework/banners';
import {BannerPosition} from '@/lib/constants';
import rangeMap from '@/lib/range-map';
import ContentLoader from 'react-content-loader';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

function MidHomeBannerSwiperMobile() {
    const {data, isLoading} = useSliderBanners({position: BannerPosition.MID_HOME_PAGE_BANNER});

    return (
        <Swiper
            modules={[Autoplay]}
            slidesPerView={isLoading ? 1.12 : 1.16}
            spaceBetween={isLoading ? 11 : 0}
            centeredSlides
            loop={true}
            updateOnWindowResize
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}>
            {isLoading
                ? rangeMap(3, i => (
                      <SwiperSlide key={i}>
                          <ContentLoader
                              speed={2}
                              width={'100%'}
                              height={'100%'}
                              backgroundColor="#ececec"
                              foregroundColor="#d6d6d6">
                              <rect x="0" y="0" rx="6" ry="6" width="100%" height="140" />
                          </ContentLoader>
                      </SwiperSlide>
                  ))
                : data?.items?.map(banner => {
                      return (
                          <>
                              {banner?.image_mobile && (
                                  <SwiperSlide key={banner?.banner_id}>
                                      {({isActive}) => (
                                          <Link href={`${banner?.url_banner}`}>
                                              <div
                                                  className={`h-[160px] mx-auto transition-all ${isActive ? 'scale-100' : 'scale-[0.92]'}`}>
                                                  <Image
                                                      className="h-full w-full rounded-md object-cover"
                                                      src={getBannerUrlByPath(banner?.image_mobile!)}
                                                      alt={banner?.name ?? 'Banner'}
                                                      width={493}
                                                      height={140}
                                                  />
                                              </div>
                                          </Link>
                                      )}
                                  </SwiperSlide>
                              )}
                          </>
                      );
                  })}
        </Swiper>
    );
}

export default MidHomeBannerSwiperMobile;
